"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormValidationOverlay = _interopRequireDefault(require("../Forms/_FormValidationOverlay"));

var _InputGroupAddon = _interopRequireDefault(require("./_InputGroupAddon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _inputGroup.default);
var isUsingCssModules = _inputGroup.default && (0, _keys.default)(_inputGroup.default).length > 0;
/** An **InputGroup** includes form inputs with add-ons that allow the user to
better understand the information being entered. */

var InputGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputGroup, _Component);

  var _super = _createSuper(InputGroup);

  function InputGroup(props) {
    (0, _classCallCheck2.default)(this, InputGroup);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(InputGroup, [{
    key: "render",
    value: function render() {
      var _context;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          compact = _this$props.compact,
          cssNamespace = _this$props.cssNamespace,
          disabled = _this$props.disabled,
          validationOverlayProps = _this$props.validationOverlayProps,
          validationState = _this$props.validationState,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "compact", "cssNamespace", "disabled", "validationOverlayProps", "validationState"]);
      var inputGroupClasses = classnames(className, "".concat(cssNamespace, "-input-group"), (0, _defineProperty2.default)({
        'is-disabled': disabled
      }, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state));

      var getClassName = function getClassName(child) {
        var _child$props$classNam, _child$type, _classnames2;

        return classnames((_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, "".concat(cssNamespace, "-input-group__input"), !((_child$props$classNam = child.props.className) === null || _child$props$classNam === void 0 ? void 0 : (0, _includes.default)(_child$props$classNam).call(_child$props$classNam, "".concat(cssNamespace, "-tokenizer")))), (0, _defineProperty2.default)(_classnames2, "".concat(cssNamespace, "-textarea"), ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'FormTextarea' && isUsingCssModules), _classnames2), child.props.className);
      };

      var inputGroup = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: inputGroupClasses
      }), (0, _map.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
        var _child$type2;

        if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === _InputGroupAddon.default.displayName) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            compact: compact,
            disabled: disabled
          });
        }

        return /*#__PURE__*/_react.default.cloneElement(child, {
          compact: compact,
          disabled: disabled,
          className: getClassName(child),
          validationState: child.props.validationState && null // remove duplicate validation state from child component

        });
      }));

      return (validationState === null || validationState === void 0 ? void 0 : validationState.state) ? /*#__PURE__*/_react.default.createElement(_FormValidationOverlay.default, (0, _extends2.default)({}, validationOverlayProps, {
        control: inputGroup,
        validationState: validationState
      })) : inputGroup;
    }
  }]);
  return InputGroup;
}(_react.Component);

InputGroup.Addon = _InputGroupAddon.default;
InputGroup.displayName = 'InputGroup';
process.env.NODE_ENV !== "production" ? InputGroup.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  })
} : void 0;

var _default = (0, _withStyles.default)(InputGroup);

exports.default = _default;